export enum ConnectionTier {
  Good = 'GOOD',
  Unstable = 'UNSTABLE',
  Weak = 'WEAK',
  Lost = 'LOST',
}

export enum NoiseSuppressionModel {
  Rnnoise = 'RNNOISE',
  Gtcrn = 'GTCRN',
}
